import { compose, withState } from 'recompose';

import DisposableForm from './disposableForm';

const enhance = compose(
  withState('isFormOpen', 'setIsFormOpen', ({ open }) => open),
);

export default enhance(DisposableForm);
